import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/tenken_data_bases'), {
      params: params || {}
    })
  },
  create(params) {
    return axios.post(utils.getApiUrl('/tenken_data_bases'), params)
  },
  show(id) {
    return axios.get(utils.getApiUrl(`/tenken_data_bases/${id}`))
  },
  update(id, params) {
    return axios.put(utils.getApiUrl(`/tenken_data_bases/${id}`), params)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/tenken_data_bases/${id}`))
  },
}
